import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { AssetEventType, GenericExternalSystemType } from "../../api/assetEvent";
import { ExternalSystem } from "../../api/externalSystemRequest";

export const RemittanceAdviceExternalSystems: ExternalSystem[] = [
    {
        title: 'Send for Reconciliation',
        description: 'Transmit your Remittance Advices to InMatch so that it can be automatically matched',
        icon: '/assets/images/inblock_logo_white.png',
        type: 'inblock',
        assetEventType: AssetEventType.ingested_inmatch,
        failMessage: 'Failed to send for Reconciliation',
        globalFailMessage: 'Remittance Advice(s) received an error when sending for Reconciliation',
        successMessage: 'Sent for Reconciliation',
        globalSuccessMessage: 'Remittance Advice(s) were successfully sent for Reconciliation',
        waitingMessage: 'Waiting for Reconciliation',
        externalSystemType: GenericExternalSystemType.inblock,
        requiredPermission: UserEntitlementCatalogs.SendForReconciliation
    },
    {
        title: 'Send to Post Trade Settlement',
        description: 'Transmit your Remittance Advices for use in the Settlement Module',
        icon: '/assets/images/x.png',
        type: 'pts',
        assetEventType: AssetEventType.pts_ingestor,
        failMessage: 'Failed to send to Post Trade Settlement',
        globalFailMessage: 'Remittance Advice(s) received an error when sending to PTS',
        successMessage: 'Sent to Post Trade Settlement',
        globalSuccessMessage: 'Remittance Advice(s) were successfully sent for Post Trade Settlement',
        waitingMessage: 'Waiting for Post Trade Settlement',
        externalSystemType: GenericExternalSystemType.pts,
        requiredPermission: UserEntitlementCatalogs.SendToPostTradeSettlement
    }
];
